import React, { useState, useEffect } from "react";
import { AUTO_ATTRS } from "components/Form/fields/constants";
import { IoIosSearch } from "@hacknug/react-icons/io";
import { useDebounce } from "utils/hooks";
import HoverIconButton from "components/HoverIconButton";
const DEFAULT_DEBOUNCE = 500;

const DEFAULT_CLASSES = {
  inputWrapper: "flex flex-row items-center pa3 bb hairline-1",
  icon: "absolute ma2",
  input: "f5 border-box input-reset ba pa2 db w-100 br2 lh-copy b--black-20"
};

const SearchBar = ({
  innerRef,
  customClasses,
  inputValue,
  debounce,
  valueSet,
  placeholder,
  showReset,
  onReset
}) => {
  const [value, setValue] = useState(inputValue || "");
  const ctxDebounce = debounce || DEFAULT_DEBOUNCE;
  useEffect(() => {
    valueSet && valueSet(value);
  }, [useDebounce(value, ctxDebounce)]);

  const classes = {
    ...DEFAULT_CLASSES,
    ...customClasses
  };
  const inputProps = {
    className: classes.input,
    type: "text",
    name: "text",
    onChange: (evt) => {
      setValue(evt.currentTarget.value);
    },
    style: {
      textIndent: "1.75rem"
    },
    value,
    ...AUTO_ATTRS,
    placeholder
  };
  if (innerRef) {
    inputProps.ref = innerRef;
  }

  return (
    <div className={classes.inputWrapper}>
      <IoIosSearch
        // style={{ marginTop: "0.3rem" }}
        className={classes.icon}
        // {...iconProps}
      />
      <div className="w-100">
        <input {...inputProps} />
      </div>
      {showReset && (
        <div className="pl2">
          <HoverIconButton
            icon="refresh"
            onClick={() => {
              setValue("");
              onReset && onReset;
            }}
          />
        </div>
      )}
    </div>
  );
};

export default SearchBar;
